<template>
    <div>
        <table class="table table-compact table-definition stack-xs">
            <tr>
                <td>Date</td>
                <td>{{value.createdTime | dateTime}}</td>
            </tr>
            <tr>
                <td>Amount</td>
                <td>{{value.lineItemSubtotal.amount | monetizeExplicit(value.lineItemSubtotal.currency)}}</td>
            </tr>
            <tr>
                <td>Status</td>
                <td><r-badge :type="getBadgeType('orderStatus', value.status)">{{value.status | unKebabCase}}</r-badge></td>
            </tr>
            <tr>
                <td>Order number</td>
                <td><router-link :to="{name: 'order-details', params: {id: value.id}}">{{value.id}}</router-link></td>
            </tr>
        </table>
    </div>
</template>

<script>
    import {getBadgeType} from '@/data/badges-color-map';

    export default {
        name: 'search-result-title-orders',
        props: {
            value: {
                type: Object,
                required: true,
            },
        },
        methods: {
            getBadgeType,
        },
    };
</script>
